<template>
  <component
    :is="validLink ? 'a' : 'div'"
    :href="item.linkedin"
    target="_blank"
  >
    <v-responsive
      :style="styles"
      class="grid-item"
      :class="[
        { 'with-background': !!backgroundImage },
        'grid-item-team-' + item.st_jude_team,
      ]"
      :aspect-ratio="['xs', 'sm'].includes($size) ? 375 / 283 : 480 / 280"
    >
      <div class="grid-item__bg"></div>

      <div class="grid-item__text">
        <v-icon size="24">{{ "$team_" + item.st_jude_team }}</v-icon>
        <div class="grid-item__name">
          {{ `${item.first_name} ${item.last_name}` }}
        </div>
        <div class="grid-item__title">{{ item.job_position }}</div>
        <hr class="hr-yellow" />
        <div class="grid-item__email">
          {{ item.email }}
        </div>
        <div class="grid-item__phone">
          <the-mask :value="item.phone" type="tel" mask="###-###-####" />
        </div>
      </div>
      <img
        v-if="validLink"
        class="grid-item__img"
        src="@/assets/networking-linkedin.png"
        width="54"
        alt=""
      />
    </v-responsive>
  </component>
</template>

<script>
export default {
  name: "GridItem",
  props: {
    item: Object,
    index: Number,
  },
  data() {
    return {
      colors: ["#8D0034", "#FDB71A", "#D11947", "#B3891F"],
    };
  },
  computed: {
    styles() {
      const styles = {
        backgroundColor: this.color,
      };

      if (this.backgroundImage) {
        styles.backgroundImage = this.backgroundImage;
      }

      styles.backgroundPositionY = `${this.item.background_position || 25}%`;

      return styles;
    },
    backgroundImage() {
      const preview = this.item.preview_urls?.large;
      if (preview) {
        return `url(${preview})`;
      }
      return null;
    },
    color() {
      return this.colors[this.index % this.colors.length];
    },
    validLink() {
      return this.item.linkedin.startsWith("https://www.linkedin.com");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.grid-item::v-deep .v-responsive__content {
  position: relative;
  z-index: 1;
}

.grid-item {
  display: flex;
  align-items: flex-end;
  padding: 20px;
  background-size: cover;
  background-position-x: center;
  background-position-y: 25%;
  position: relative;

  * {
    color: $jude-white;
  }

  .v-icon {
    color: $jude-yellow;
    margin-bottom: 4px;
  }

  &.with-background:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(26, 26, 26, 0.48);
  }

  &:hover {
    filter: brightness(105%);
  }

  hr {
    width: 320px;
    margin: 6px 0 10px;
  }

  &__name {
    font-weight: 800;
    font-size: 24px;
    line-height: 30px;
  }

  &__title {
    font-weight: 800;
    font-size: 16px;
    line-height: 18px;
  }

  &__email,
  &__phone {
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;

    letter-spacing: 0.02em;
    text-shadow: 0px 3px 4px rgba(0, 0, 0, 0.5);
  }

  &__img {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}

a {
  text-decoration: none;
}

@media screen and (max-width: 960px) {
  .grid-item {
    &__text {
      max-width: calc(100% - 80px);
    }
    hr {
      width: unset;
    }
  }
}
</style>
